import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { saveAs } from 'file-saver';
import { UtilService } from './util-service';
import { Irregularidade } from '../models/Irregularidade';

/*
  Generated class for the TiposIrregularidadesService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class TiposIrregularidadesService {

  constructor(http: HttpClient,
    private utilService: UtilService) {
  }

  /*================================================================
  *
  *  Irregularidades
  *
  ==================================================================*/
  public criaIrregularidade() {
    return new Irregularidade();
  }

  public listarTiposIrregularidades(): Observable<any> {
    let urlObtencaoDados: string = "irregularidade/listar";
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public listarTiposIrregularidadesPorModulo(idModulo): Observable<any> {
    let urlObtencaoDados: string = "irregularidade/listarPorModulo/" + idModulo;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public listarClassificacao(): Observable<any> {
    let urlObtencaoDados: string = "classificacao/listar";
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public buscarTipoIrregularidade(idIrregularidade): Observable<any> {
    let urlObtencaoDados: string = "irregularidade/buscar/" + idIrregularidade;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public deletarTipoIrregularidade(idIrregularidade): Observable<any> {
    let urlObtencaoDados: string = "irregularidade/deletar/" + idIrregularidade;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public salvarNovoTipoIrregularidade(jsonObjeto): Observable<any> {
    let urlObtencaoDados: string = "irregularidade/salvar";
    return this.utilService.postJSON(urlObtencaoDados, jsonObjeto);
  }

  public downloadTemplateIrregularidadesMassa() {
    let path = "irregularidade/downloadTemplateImportacao";
    var headers = new HttpHeaders();
    headers.append('responseType', 'arraybuffer');
    this.utilService.getJSON(path)
      .subscribe(data => {
        let contentType = "data:" + data.mimeType + ";base64";

        let byteCharacters = atob(data.decodedFile);

        let byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], { type: contentType });
        saveAs(file, "Template_importação_irregularidade_em_massa.xlsx");
      },
      error => console.log("Error downloading the file. error: " + error));
  }

  public salvarEmMassa(event) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('xlsIrregularidade', file, file.name);
      let envioRolXml: string = "irregularidade/importar";
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

  /*================================================================
  *
  *  Assunto
  *
  ==================================================================*/
  public listarAssuntos(): Observable<any> {
    let urlObtencaoDados: string = "assunto/listar";
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public buscarAssunto(idAssunto): Observable<any> {
    let urlObtencaoDados: string = "assunto/buscar/" + idAssunto;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public deletarAssunto(idAssunto): Observable<any> {
    let urlObtencaoDados: string = "assunto/deletar/" + idAssunto;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public salvarNovoAssunto(jsonObjeto): Observable<any> {
    let urlObtencaoDados: string = "assunto/salvar";
    return this.utilService.postJSON(urlObtencaoDados, jsonObjeto);
  }

  /*================================================================
  *
  *  Subassunto
  *
  ==================================================================*/
  public listarSubAssuntos(): Observable<any> {
    let urlObtencaoDados: string = "subassunto/listar";
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public buscarSubAssunto(idSubassunto): Observable<any> {
    let urlObtencaoDados: string = "subassunto/buscar/" + idSubassunto;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public deletarSubAssunto(idSubassunto): Observable<any> {
    let urlObtencaoDados: string = "subassunto/deletar/" + idSubassunto;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public salvarNovoSubAssunto(jsonObjeto): Observable<any> {
    let urlObtencaoDados: string = "subassunto/salvar";
    return this.utilService.postJSON(urlObtencaoDados, jsonObjeto);
  }

  /*================================================================
  *
  *  Classificaçao
  *
  ==================================================================*/
  public listarClassificacoes(): Observable<any> {
    let urlObtencaoDados: string = "classificacao/listar";
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public buscarClassificacao(idClassificacao): Observable<any> {
    let urlObtencaoDados: string = "classificacao/buscar/" + idClassificacao;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public deletarClassificacao(idClassificacao): Observable<any> {
    let urlObtencaoDados: string = "classificacao/deletar/" + idClassificacao;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public salvarNovaClassificacao(jsonObjeto): Observable<any> {
    let urlObtencaoDados: string = "classificacao/salvar";
    return this.utilService.postJSON(urlObtencaoDados, jsonObjeto);
  }

  /*================================================================
  *
  *  Legislacao
  *
  ==================================================================*/
  public listarLegislacoes(): Observable<any> {
    let urlObtencaoDados: string = "legislacao/listar";
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public buscarLegislacao(idLegislacao): Observable<any> {
    let urlObtencaoDados: string = "legislacao/buscar/" + idLegislacao;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public deletarLegislacao(idLegislacao): Observable<any> {
    let urlObtencaoDados: string = "legislacao/deletar/" + idLegislacao;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public salvarNovaLegislacao(jsonObjeto): Observable<any> {
    let urlObtencaoDados: string = "legislacao/salvar";
    return this.utilService.postJSON(urlObtencaoDados, jsonObjeto);
  }

  /*================================================================
  *
  *  Modulos
  *
  ==================================================================*/
  public listarModulos(): Observable<any> {
    let urlObtencaoDados: string = "modulo/listarModulos";
    return this.utilService.getJSON(urlObtencaoDados);
  }

}



// WEBPACK FOOTER //
// ./src/providers/tipos-irregularidades-service.ts